var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.5 148.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f1a18;\n      }\n\n      .cls-2 {\n        fill: #b09365;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 74.25,
    cy: 74.25,
    r: 74.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.92,113.39c.31-6.25,7.4-12.67,12.48-15.84,16.43-10.26,39.98-8.2,53.1,6.52,1.73,1.94,7.76,9,3.1,10.1-13.49-18.55-40.75-22.93-58.96-8.52-1.46,1.15-8.18,9.33-9.71,7.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.26,53.89c4.95-5.5,10.38,2.1,10.65,7.16.14,2.57-1.79,9.48-4.45,10.3-9.13,2.81-10.97-12.15-6.2-17.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.46,52.23c10.04-2.08,10.06,18.53,2.06,19.26-8.59.79-9.48-17.72-2.06-19.26Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFilled);
export default __webpack_public_path__ + "static/media/SadFilled.33ccbf3d9cf714e68925bf9d61c6c796.svg";
export { ForwardRef as ReactComponent };